import React, { memo, forwardRef } from 'react';
import PropTypes from 'prop-types';

import TextField from 'components/TextField';

import { Wrapper, CancelButton } from './styles';

const ModalSelectSearchInput = forwardRef(
  (
    {
      isFocused,
      value,
      placeholder,
      label,
      cancelLabel,
      onFocus,
      onBlur,
      onChange,
      onCancel,
      className,
    },
    ref
  ) => (
    <Wrapper ref={ref} isFocused={isFocused} className={className}>
      <TextField
        type="text"
        placeholder={isFocused ? label || placeholder : placeholder}
        icon="search"
        value={value}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        autoComplete="off"
        autoCapitalize="off"
        spellCheck="false"
      />

      {isFocused && (
        <CancelButton onClickCapture={onCancel}>{cancelLabel}</CancelButton>
      )}
    </Wrapper>
  )
);

ModalSelectSearchInput.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  cancelLabel: PropTypes.string,
  isFocused: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onCancel: PropTypes.func,
  className: PropTypes.string,
};

ModalSelectSearchInput.defaultProps = {
  value: '',
  label: null,
  placeholder: '',
  cancelLabel: '',
  isFocused: false,
  onFocus: () => {},
  onBlur: () => {},
  onChange: () => {},
  onCancel: () => {},
  className: '',
};

export default memo(ModalSelectSearchInput);
